export class Dialog {
	title:any = null;
	text:any = "";
	buttonText?:any = "ok";
	dismisable = false;
	onDismis?:any;
	className:any = null;
}